<mat-accordion [displayMode]="'flat'"
               [togglePosition]="'before'"
>
    @for (group of allGroups; track group.id) {
        <mat-expansion-panel class="accordion-item" hideToggle="true" #panel [expanded]="group.id===activeGroup">
            <mat-expansion-panel-header
                    [collapsedHeight]="'48px'"
                    [expandedHeight]="'48px'"
            >
                <mat-panel-title>
                    <div class="accordion-item-title" >
                        <input  matInput  type="text" [formControl]="groupTitlesFCs.controls[$index]" *ngIf="groupTitlesFCs.controls[$index]">
                        <mat-icon *ngIf="!panel.expanded" svgIcon="arrow-down-s-line"></mat-icon>
                        <mat-icon *ngIf="panel.expanded" svgIcon="arrow-up-s-line"></mat-icon>
                    </div>
                </mat-panel-title>
                <mat-icon *ngIf="groupTitlesFCs.controls[$index]?.value !==group?.title"
                        (click)="changeTitle(group.id, groupTitlesFCs.controls[$index],$event)"
                        svgIcon="edit-line" class = "accordion-item-hover-icon" 
                        [matTooltip]=" 'BUTTON_TEXT.SAVE' | translate " >
                </mat-icon>
                <mat-icon  (click)="deleteBoardGroup(group.id, group.title,$event )"
                        svgIcon="delete-bin-6-line" class = "accordion-item-hover-icon" 
                        [class.disabled-icon]="group.boards?.length>0 || currentMember?.project_setting?.is_project_admin !== true" 
                        [matTooltip]=" 'BUTTON_TEXT.DELETE' | translate "
                ></mat-icon>
            </mat-expansion-panel-header>
            
            <ng-container *ngTemplateOutlet="boardsTemplate, context:{'boards' : group.boards}"></ng-container>
        </mat-expansion-panel>
    }

    <mat-expansion-panel class="accordion-item" hideToggle="true" [expanded]="activeGroup === -1" #panel>
        <mat-expansion-panel-header
                [collapsedHeight]="'48px'"
                [expandedHeight]="'48px'"
        >
            <mat-panel-title>
                <div class="accordion-item-title" >
                    <span> {{ 'INDEX_PAGE.BUSINESS_PROCESS.TEXT.BP_LIST' | translate }} </span> 
                    <mat-icon *ngIf="!panel.expanded" svgIcon="arrow-down-s-line"></mat-icon>
                    <mat-icon *ngIf="panel.expanded" svgIcon="arrow-up-s-line"></mat-icon>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <span class="boards-container-item-content-description" 
            style="margin-top: -10px; font-family: Onest; width: 100%; text-align: right;">
            Global search is on
        </span>
        <ng-container *ngTemplateOutlet="boardsTemplate, context:{boards: boards}"></ng-container>

    </mat-expansion-panel>
</mat-accordion>

<ng-template let-boards="boards"
             #boardsTemplate
>
    <div class="boards-container">
        @for (board of boards; track board.alias) {
            <div class="boards-container-item"
                 (click)="goTo($event, board, 'table')"
            >
                <div class="boards-container-item-header">
                    <i *ngIf="board.icon?.substring(0,2) ==='bi'"
                        class="boards-container-item-header-icon"
                       [class]="board.icon"
                    ></i>
                    <div *ngIf="board.icon?.substring(0,2) !=='bi'" class="boards-container-item-header-bg-icon" >
                        <mat-icon  [svgIcon]="board.icon" class="base-icon"></mat-icon>
                    </div>
                    <span>{{ board.alias }}</span>
                    <span class="boards-container-item-header-action-icon">
                        <mat-icon (click)="goTo($event, board, 'settings')" svgIcon="settings-4-fill" class="secondary-icon"></mat-icon>
                    </span>
                </div>
                <div class="boards-container-item-content">
                    <span class="boards-container-item-content-name"
                    >
                        {{ board.name }}
                    </span>

                    <div class="boards-container-item-content-description"
                         [matTooltip]="board.description"
                         matTooltipClass="bp-tooltip-class"
              
                         [innerHTML]="board.description"
                    ></div>
                </div>
            </div>
        } @empty {
            <div class="body-l-regular text-extra">{{ 'EMPTY_LISTS.BOARDS' | translate }}</div>
        }
    </div>
</ng-template>


<!--<ng-template #settingsView let-modal>-->
<!--    <app-button-modal-close [modal]="modal"></app-button-modal-close>-->
<!--    <div class="modal-body">-->
<!--        <app-board-settings-modal-->
<!--                (emitReloading)="emitReloading.emit($event)"-->
<!--                [board]="selectedBoard"-->
<!--        ></app-board-settings-modal>-->
<!--    </div>-->
<!--</ng-template>-->
